import { ExternalLink } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-slate-800 bg-slate-950 no-print" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <img
            src="/nirmandwar_logo_mark.png"
            alt="NirmanDwar logo"
            className="h-10 w-10 rounded-full bg-white object-cover ring-2 ring-orange-500/40"
          />
          <div>
            <span className="font-heading font-extrabold text-lg text-white">
              Nirman<span className="text-orange-500">Dwar</span>
              <sup className="text-[0.5em] font-semibold text-orange-400 ml-0.5">™</sup>
            </span>
            <p className="text-xs text-slate-500">nirmandwar.com · Construction Cost & Material Calculator</p>
          </div>
        </div>
        <a
          href="https://nirmandwar.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-orange-400 transition-colors"
        >
          Compare material prices from 1700+ suppliers on nirmandwar.com
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
      <p className="mt-8 text-xs text-slate-600 leading-relaxed">
        Estimates are indicative and based on standard Indian construction benchmarks (IS Code /
        CPWD thumb rules) for 2026. Actual costs vary by design, specifications, site conditions and
        prevailing market rates. © {new Date().getFullYear()} NirmanDwar.
      </p>
    </div>
  </footer>
);
